var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaypall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#E8F9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 34H16V14H31V34Z",
    stroke: "#E5E7EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3516 25.5586C20.2149 26.3086 19.6719 29.8047 19.5117 30.793C19.5 30.8633 19.4727 30.8906 19.3945 30.8906H16.4805C16.1836 30.8906 15.9688 30.6328 16.0078 30.3477L18.2969 15.8203C18.3555 15.4453 18.6914 15.1602 19.0781 15.1602C25.0274 15.1602 25.5274 15.0156 27.0469 15.6055C29.3945 16.5156 29.6094 18.7109 28.7656 21.0859C27.9258 23.5313 25.9336 24.582 23.293 24.6133C21.5977 24.6406 20.5781 24.3399 20.3516 25.5586ZM29.9492 19.9375C29.8789 19.8867 29.8516 19.8672 29.832 19.9883C29.7539 20.4336 29.6328 20.8672 29.4883 21.3008C27.9297 25.7461 23.6094 25.3594 21.5 25.3594C21.2617 25.3594 21.1055 25.4883 21.0742 25.7266C20.1914 31.2109 20.0156 32.3555 20.0156 32.3555C19.9766 32.6328 20.1524 32.8594 20.4297 32.8594H22.9102C23.2461 32.8594 23.5234 32.6133 23.5899 32.2774C23.6172 32.0664 23.5469 32.5156 24.1524 28.7109C24.332 27.8516 24.7109 27.9414 25.2969 27.9414C28.0703 27.9414 30.2344 26.8164 30.8789 23.5547C31.1328 22.1953 31.0586 20.7656 29.9492 19.9375Z",
    fill: "#179BD7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypall);
export default __webpack_public_path__ + "static/media/paypall.b124d3f1a50f25cc480287343b648bf8.svg";
export { ForwardRef as ReactComponent };